"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var storeApi = _interopRequireWildcard(require("@/api/store"));
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var toolUtils = _interopRequireWildcard(require("@/utils/toolUtils.js"));
var _componentsApi = require("@/api/componentsApi");
var fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi.js"));
var _uploadFile = _interopRequireDefault(require("@/components/Upload/uploadFile.vue"));
var categoryApi = _interopRequireWildcard(require("@/api/categoryApi.js"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    UploadFile: _uploadFile.default
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {},
      jdCateIdsOption: [],
      // 京东商品分类
      cateIdsOption: [],
      // 商品分类
      brandOption: [],
      // 品牌
      excelData: [],
      initSourceType: null,
      initType: null,
      userType: null
    };
  },
  mounted: function mounted() {
    this.getInit();
    this.userType = JSON.parse(_jsCookie.default.get('JavaInfo')).type;
  },
  methods: {
    throttle: _throttle.default,
    downModal: function () {
      var _downModal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _componentsApi.excelTemplateApi)('label_product.xlsx');
            case 1:
              res = _context.v;
              toolUtils.downloadFile(res.fileName, '商品标签批量模版');
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      function downModal() {
        return _downModal.apply(this, arguments);
      }
      return downModal;
    }(),
    openInit: function openInit(details) {
      this.excelData = [];
      this.pram = _objectSpread({}, details);
      this.loading = false;
      this.getChannelBind(details.id);
      this.visible = true;
    },
    getChannelBind: function getChannelBind(channelId) {
      var _this = this;
      this.initSourceType = null;
      this.initType = null;
      if (!channelId) return;
      fudouActiveApi.getChannelBind(channelId).then(function (res) {
        var _content$split;
        var _ref = res || {},
          sourceType = _ref.sourceType,
          type = _ref.type,
          content = _ref.content;
        _this.initSourceType = sourceType ? JSON.parse(JSON.stringify(sourceType)) : null;
        _this.initType = type ? JSON.parse(JSON.stringify(type)) : null;
        var keyMap = {
          1: {
            cateIds: content && content != "" ? JSON.parse(content) : []
          },
          2: {
            tagIds: content && content != "" && (content === null || content === void 0 ? void 0 : (_content$split = content.split(',')) === null || _content$split === void 0 ? void 0 : _content$split.map(function (item) {
              return Number(item);
            })) || []
          },
          3: {
            url: content
          }
        };
        _this.pram = _objectSpread(_objectSpread(_objectSpread({}, res), _this.pram), keyMap[type]);
      });
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        var _ref2 = _this2.pram || {},
          type = _ref2.type,
          id = _ref2.id,
          url = _ref2.url,
          _ref2$tagIds = _ref2.tagIds,
          tagIds = _ref2$tagIds === void 0 ? [] : _ref2$tagIds,
          cateIds = _ref2.cateIds,
          sourceType = _ref2.sourceType;
        var contentMap = {
          1: JSON.stringify(cateIds),
          2: tagIds === null || tagIds === void 0 ? void 0 : tagIds.join(','),
          3: url
        };
        fudouActiveApi.goodsBindChannel({
          channelId: id,
          content: contentMap[type],
          type: type,
          sourceType: sourceType
        }).then(function (res) {
          _this2.$message.success('操作成功!');
          _this2.visible = false;
          _this2.$emit('doRefresh');
          _this2.loading = false;
        }).catch(function (err) {
          _this2.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    getInit: function getInit() {
      var _this3 = this;
      this.cateIdsOption = [];
      storeApi.categoryApi({
        status: -1,
        type: 1
      }).then(function (res) {
        _this3.cateIdsOption = _this3.addDisabled(res);
      });
      // this.searchBrand('');
      this.getJdCate();
    },
    getJdCate: function getJdCate() {
      var _this4 = this;
      this.jdCateIdsOption = [];
      categoryApi.jdCateLists().then(function (res) {
        _this4.jdCateIdsOption = res;
      });
    },
    addDisabled: function addDisabled() {
      var _this5 = this;
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var list = [];
      arr && arr.length && arr.forEach(function (e, index) {
        var e_new = _objectSpread(_objectSpread({}, e), {}, {
          disabled: !e.status
        });
        if (e.child) {
          var childList = _this5.addDisabled(e.child);
          e_new = _objectSpread(_objectSpread({}, e_new), {}, {
            child: childList
          });
        }
        list.push(e_new);
      });
      return list;
    },
    searchBrand: function searchBrand() {
      var _this6 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      // storeApi.getLabelApi({keyword, type: this.pram?.sourceType}).then(res=>{
      storeApi.getLabelApi(keyword).then(function (res) {
        _this6.brandOption = res || [];
      });
    },
    changeSourceType: function changeSourceType() {
      var _ref3 = this.pram || {},
        sourceType = _ref3.sourceType,
        type = _ref3.type,
        id = _ref3.id;
      // sourceType && this.searchBrand('');
      this.pram = {
        sourceType: sourceType,
        type: type,
        id: id
      };
      if (sourceType == 2 && type == 2) {
        var _this$pram;
        (_this$pram = this.pram) === null || _this$pram === void 0 ? true : delete _this$pram.type;
      }
      ;
    }
  },
  props: {
    miniProgramCustomer: {
      type: Boolean,
      default: false
    }
  }
};